import RequirePermissions from '@/components/auth/requirePermissions';
import getConfigValue from '@/config';
import { useGetBatchGroupsQuery } from '@/services/payouts';
import { BatchComponent } from '@/types/Payouts';
import { Box, Button, Card, DateInput } from '@palmetto/palmetto-components';
import { skipToken } from '@reduxjs/toolkit/query';
import { DateTime } from 'luxon';
import { useState } from 'react';

import { IsoDateString, BatchReviewStatus, UserPermissions } from 'types';

import { BatchesList } from '../BatchesList';

const api = getConfigValue('VITE_APP_API_BASE_URL');

export const Paid = () => {
  const defaultStartDate = DateTime.now().minus({ days: 30 }).toJSDate();
  const defaultEndDate = DateTime.now().plus({ day: 2 }).endOf('day').toUTC().toJSDate();

  const [startCutoffDate, setStartDate] = useState<Date | null>(defaultStartDate || null);
  const [endCutoffDate, setEndDate] = useState<Date | null>(defaultEndDate || null);

  const setDate = ([startDate, endDate]: [Date | null, Date | null]) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
  };

  const { data: batches, isLoading: isLoadingBatches } = useGetBatchGroupsQuery(
    startCutoffDate && endCutoffDate
      ? {
          startCutoffDate: startCutoffDate?.toISOString().substring(0, 10) as IsoDateString,
          endCutoffDate: endCutoffDate?.toISOString().substring(0, 10) as IsoDateString,
          batchReviewStatus: BatchReviewStatus.approved,
        }
      : skipToken,
  );

  return (
    <>
      <Card>
        <Box
          padding="sm lg"
          childGap="xs"
          overflow="auto"
          background="tertiary"
          radius={{ base: '0', desktop: 'md' }}
          position="sticky"
          style={{ top: '0' }}
          zIndex="sticky"
          direction={{ base: 'column', tablet: 'row' }}
          justifyContent="space-between"
        >
          <Box>
            <DateInput
              datePickerProps={{
                onChange: (date) => setDate(date as [Date | null, Date | null]),
                selected: startCutoffDate,
                selectsRange: true,
                startDate: startCutoffDate,
                endDate: endCutoffDate,
              }}
              textInputProps={{
                onClear: handleClear,
                id: 'rangePickerDate',
                name: 'rangePickerDate',
                label: 'Select Date Range',
              }}
            />
          </Box>
          <RequirePermissions permissions={[UserPermissions.lightReachAccountingAdmin]} checkAllPermissions={false}>
            <Box justifyContent="center">
              <Button
                as="a"
                target="_blank"
                rel="noopener noreferrer"
                href={`${api}/payouts/batch-groups?format=csv&startCutoffDate=${startCutoffDate?.toISOString().substring(0, 10)}&endCutoffDate=${endCutoffDate?.toISOString().substring(0, 10)}&batchReviewStatus=${BatchReviewStatus.approved}`}
              >
                Export
              </Button>
            </Box>
          </RequirePermissions>
        </Box>
      </Card>
      {!isLoadingBatches && batches && <BatchesList batches={batches} originComponent={BatchComponent.paid} />}
    </>
  );
};
